import { API_BASE } from './api-base';

// Client-side counterpart to lib/report-error.ts. Ships an error the browser hit to
// /api/client-error, which is the only route into app_logs from here.
//
// Everything about this is fire-and-forget: it never awaits, never retries, never
// throws, and never tells the user. A screen that is already broken must not also
// show a reporting failure.

let sent = 0;
// One page load only needs to say "this broke" once or twice. A render throw can
// recur every frame; past this the tail carries no information.
const MAX_PER_PAGE = 3;

export type ClientErrorKind = 'render' | 'window' | 'unhandled-rejection';

export function reportClientError(kind: ClientErrorKind, err: unknown, route?: string): void {
  if (typeof window === 'undefined' || sent >= MAX_PER_PAGE) return;
  sent += 1;
  try {
    const message = err instanceof Error ? err.message : String(err);
    const stack = err instanceof Error && err.stack ? err.stack : '';
    void fetch(`${API_BASE}/api/client-error`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      credentials: 'include',
      // Survives the page being torn down mid-report, which is the likely case for
      // an error thrown during navigation.
      keepalive: true,
      body: JSON.stringify({ kind, message, stack, route: route ?? '' }),
    }).catch(() => {});
  } catch {
    /* ignore */
  }
}
